/**
 * 项目全部使用的正则规则 import regRule from '@/app-shared/utils/reg-rule.js';
 */
const regRule = {
  get mobile() {
    //移动手机号
    return new RegExp(/^1\d{10}$/g);
  },
  get mobileForeign() {
    //国外手机号
    return new RegExp(/^\d{1,15}$/);
  },
  get mobileForeign2() {
    //国外手机号2
    return new RegExp(/^\d{1,20}$/);
  },
  get pwd() {
    return new RegExp(/^([0-9a-zA-Z]){6,30}$/);
  }, //可输入密码情况,
  get newPwd() {
    return new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,30}$/);
  },
  get email() {
    return new RegExp(/^[A-Za-z0-9]+[A-Za-z0-9-_.]*@([A-Za-z0-9-_]+)(\.[A-Za-z0-9-_]+){1,4}$/);
  }, //邮箱
  get isMobile() {
    return new RegExp(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|wOSBrowser|BrowserNG|WebOS)/i);
  }, //是否移动端
  urlAnalysis(name) {
    // 解析地址栏参数
    return new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  },
  getCookie(name) {
    //获取浏览器的cookie
    return new RegExp(name + '=([^;]+)');
  },
  get img() {
    return new RegExp(/<img.*?(?:>|\/>)/g);
  },
  get url() {
    return new RegExp(
      /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/g
    );
  },
  get numOrDecimals() {
    return new RegExp(/^\d+$|^\d*\.\d+$/g);
  }, //数字或者小数
  get numOrDecimals2() {
    return new RegExp(/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/);
  }, //数字或者2位小数
  get code() {
    return new RegExp(/^\d{4,6}$/);
  }, //4-6位数字验证码
  get code2() {
    return new RegExp(/^\d{6}$/);
  }, //6位数字验证码
  get dealChatReply() {
    return new RegExp(/^[回复].+[:]\s/);
  }, //处理聊天 回复
  get noNumPoint() {
    return new RegExp(/[^\d^.]+/g);
  }, //非数字和小数点
  get num1() {
    return new RegExp(/^[0-9]{1}$/);
  }, //一位数字
  get noNum() {
    return new RegExp(/^(0+)|[^\d]+/g);
  }, //非数字和以0开头
  get replaceNoNum() {
    return new RegExp(/^((?!^[1-9]([0-9]+)?$).)*/g);
  }, // 过滤非数字
  get pullUrl() {
    return new RegExp(/^(rtmp|http|https):\/\/.+/g);
  }, //拉流地址 rtmp://以及http://开头
  get positiveInt() {
    return new RegExp(/^(0|[1-9][0-9]*)$/);
  }, //正整数
  get positiveInt0() {
    return new RegExp(/^[1-9][0-9]*$/);
  }, //非0正整数
  get PRC() {
    return new RegExp(/[\u4E00-\u9FA5]/g);
  }, //中文
  get num() {
    return new RegExp(/^\d+$/);
  }, //数字
  get num7() {
    return new RegExp(/^([1-9][0-9]{0,6})$/);
  } // 至多7位数字
};

export default regRule;
